"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getData = void 0;
const initializer_1 = require("../initializer");
const getData = () => {
    return initializer_1.UsdManager?.data;
};
exports.getData = getData;
//# sourceMappingURL=usd.helper.js.map